import { Typography } from '@mui/material'
import PayloadEditor from './PayloadEditor'

export const AssetSourceView = ({ content, isLoading }: { content: string | undefined; isLoading: boolean }) => (
  <>
    <Typography variant="h6" sx={{ flexShrink: 0 }}>
      Payload
    </Typography>
    {isLoading ? (
      <Typography variant="body2" color="text.secondary">
        Loading...
      </Typography>
    ) : (
      <PayloadEditor value={content} editable={false} />
    )}
  </>
)
